import { hotRank } from "@/mocks/homeData";

const tagStyle: Record<string, string> = {
  爆: "bg-primary-500 text-background-50",
  热: "bg-primary-100 text-primary-800",
  新: "bg-accent-100 text-accent-900",
};

export default function HotRank() {
  return (
    <section id="rank" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
        <div>
          <span className="mb-3 inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium tracking-wider text-secondary-800">
            <i className="ri-fire-fill text-primary-500"></i>
            实时热度
          </span>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-[34px]">
            今日热议榜
          </h2>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">
            围观群众此刻都在看什么，点进去就有完整来龙去脉。
          </p>
        </div>
        <div className="mb-1 flex items-center gap-2 text-sm text-foreground-500">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-secondary-500 opacity-60"></span>
            <span className="relative inline-flex h-2 w-2 rounded-full bg-secondary-500"></span>
          </span>
          每 5 分钟刷新一次
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-3 lg:grid-cols-2">
        {hotRank.map((it) => (
          <article
            key={it.rank}
            className="group flex cursor-pointer gap-4 rounded-2xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200 hover:bg-background-100 md:p-5"
          >
            <div className="flex w-10 flex-col items-center">
              <span
                className={`font-heading text-2xl font-bold md:text-[28px] ${
                  it.rank <= 3 ? "text-primary-500" : "text-background-400"
                }`}
              >
                {String(it.rank).padStart(2, "0")}
              </span>
            </div>
            <div className="min-w-0 flex-1">
              <div className="mb-2 flex items-center gap-2">
                <span
                  className={`rounded-md px-2 py-0.5 text-[11px] font-bold ${tagStyle[it.tag] ?? "bg-background-200 text-foreground-600"}`}
                >
                  {it.tag || it.tab}
                </span>
                <span className="truncate text-xs text-foreground-400">{it.tab}</span>
              </div>
              <h3 className="mb-1.5 line-clamp-2 text-sm font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-[15px]">
                {it.title}
              </h3>
              <p className="mb-3 line-clamp-2 text-[13px] leading-relaxed text-foreground-600">
                {it.summary}
              </p>
              <div className="flex items-center gap-4 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-chat-3-line text-primary-500"></i>
                  {it.replies} 条讨论
                </span>
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-fire-line text-accent-500"></i>
                  热度 {it.heat}
                </span>
                <span className="ml-auto hidden items-center gap-1 text-primary-600 opacity-0 transition group-hover:opacity-100 sm:inline-flex">
                  进去围观 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          </article>
        ))}
      </div>

      <div className="mt-6 text-center">
        <button className="whitespace-nowrap rounded-full border border-primary-300 px-6 py-2.5 text-sm font-medium text-primary-700 transition hover:bg-primary-50">
          查看完整榜单 <i className="ri-arrow-down-line ml-1"></i>
        </button>
      </div>
    </section>
  );
}